import { onBeforeUnmount, watch, type Ref } from 'vue';

export interface UseOutsidePointerOptions {
  active: Ref<boolean>;
  handler: () => void;
}

export function useOutsidePointer(root: Ref<HTMLElement | null>, options: UseOutsidePointerOptions): void {
  const { active, handler } = options;

  if (typeof document === 'undefined') {
    return;
  }

  const onOutsidePointer = (event: MouseEvent): void => {
    const el = root.value;
    const target = event.target as Node | null;
    if (el && target && !el.contains(target)) {
      handler();
    }
  };

  watch(active, (isActive) => {
    if (isActive) {
      document.addEventListener('mousedown', onOutsidePointer);
    } else {
      document.removeEventListener('mousedown', onOutsidePointer);
    }
  });

  onBeforeUnmount(() => {
    document.removeEventListener('mousedown', onOutsidePointer);
  });
}
